(function () {
  'use strict';

  // Long enough to ignore a cursor crossing the bar on its way elsewhere,
  // short enough that a deliberate hover still feels immediate.
  var OPEN_INTENT = 70;
  // Survives the cursor clipping a gap between items or dipping below the bar.
  var CLOSE_GRACE = 160;

  function rootFontPx() {
    return parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
  }

  // --acw-pad is authored in rem and changes at the tight breakpoint, so it
  // has to be read at measure time rather than assumed.
  function toPx(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return 0;
    return value.indexOf('rem') >= 0 ? n * rootFontPx() : n;
  }

  function wire(nav) {
    var items = Array.prototype.slice.call(nav.querySelectorAll('.acw-nav__item'));
    if (!items.length) return;

    var openTimer = null;
    var closeTimer = null;
    var lastIndex = -1;

    var bar = document.createElement('span');
    bar.className = 'acw-nav__travel';
    bar.setAttribute('aria-hidden', 'true');
    nav.appendChild(bar);
    // Tells the stylesheet to stand down the per-link underlines, and is only
    // ever set once the bar actually exists to replace them.
    nav.classList.add('acw-nav--travel');

    function moveBar(item) {
      var link = item.querySelector('.acw-nav__link') || item;
      var navBox = nav.getBoundingClientRect();
      var linkBox = link.getBoundingClientRect();
      if (!linkBox.width) return;

      var pad = toPx(getComputedStyle(nav).getPropertyValue('--acw-pad').trim());
      var x = linkBox.left - navBox.left + pad;
      var w = Math.max(0, linkBox.width - pad * 2);

      // Sliding in from a hidden bar would animate from a stale position, so
      // the first appearance is placed silently and only fades in.
      var showing = bar.classList.contains('acw-nav__travel--on');
      if (!showing) {
        bar.classList.add('acw-nav__travel--place');
        bar.style.transform = 'translateX(' + x + 'px)';
        bar.style.width = w + 'px';
        void bar.offsetWidth; // commit the jump before re-enabling travel
        bar.classList.remove('acw-nav__travel--place');
        bar.classList.add('acw-nav__travel--on');
        return;
      }

      bar.style.transform = 'translateX(' + x + 'px)';
      bar.style.width = w + 'px';
    }

    function hideBar() {
      bar.classList.remove('acw-nav__travel--on');
    }

    function setDirection(index) {
      if (lastIndex >= 0 && index !== lastIndex) {
        nav.classList.toggle('acw-nav--fwd', index > lastIndex);
        nav.classList.toggle('acw-nav--back', index < lastIndex);
      }
      lastIndex = index;
    }

    function markOpen() {
      clearTimeout(closeTimer);
      closeTimer = null;
      nav.classList.add('acw-nav--open');
    }

    function enter(index, item) {
      setDirection(index);
      moveBar(item);
      // Already open means this is a switch, not an arrival — no gate.
      if (nav.classList.contains('acw-nav--open')) {
        markOpen();
        return;
      }
      clearTimeout(openTimer);
      openTimer = setTimeout(markOpen, OPEN_INTENT);
    }

    function leave() {
      clearTimeout(openTimer);
      openTimer = null;
      hideBar();
      lastIndex = -1;
      nav.classList.remove('acw-nav--fwd');
      nav.classList.remove('acw-nav--back');
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        nav.classList.remove('acw-nav--open');
      }, CLOSE_GRACE);
    }

    // Armed on every item, including those without a panel: the cursor is
    // still travelling along the bar, so the next panel it reaches should
    // open instantly rather than treating the trip as a fresh arrival.
    items.forEach(function (item, index) {
      item.addEventListener('pointerenter', function () {
        enter(index, item);
      });
      // Keyboard tabbing is always deliberate, so it skips the intent gate.
      item.addEventListener('focusin', function () {
        setDirection(index);
        moveBar(item);
        markOpen();
      });
    });

    // Panels are descendants of their item, which is inside the nav, so
    // moving down into one never leaves this element.
    nav.addEventListener('pointerleave', leave);
    nav.addEventListener('focusout', function (event) {
      if (!nav.contains(event.relatedTarget)) leave();
    });

    // A resize changes every measurement the bar depends on. Parking it is
    // cheaper and steadier than recomputing against a layout mid-reflow.
    window.addEventListener('resize', hideBar);
  }

  function init() {
    // Reduced motion already strips every nav transition, so there is no
    // sequence left to smooth — and the per-link underlines stay in place,
    // which is the correct static fallback.
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    var navs = document.querySelectorAll('.acw-nav');
    for (var i = 0; i < navs.length; i++) wire(navs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
